/* eslint-disable import/prefer-default-export */
export const setLabelErrorClass = (containerID, field, isValid) => {
  const container = document.getElementById(containerID);
  const fieldEl = container.querySelector(`[data-gigya-name='${field}']`);
  const parent = fieldEl.parentElement;
  const label = parent.querySelector('.gigya-label');
  if (isValid) label.classList.remove('gigya-error');
  else label.classList.add('gigya-error');
};
